module.exports = __webpack_public_path__ + "Server-Unknown.AzureWebApp.2f18a4b6b1028d212525bd1011001e74.hashedasset.svg";